export default function () {
  return {
    loadingSignComplete: false
  };
}
